//@flow
import Enum from './Enum';

export const PlanStatusEnum = new Enum({
    Received: 'RECEIVED',
    Planning: 'PLANNING',
    Planned: 'PLANNED',
    Frozen: 'FROZEN',
    Assigned: 'ASSIGNED',
    Assigning: 'ASSIGNING',
    Terminated: 'TERMINATED',
    Error: 'ERROR'
});

export const PlanConfigureEnum = new Enum({
    Default: 'DEFAULT',
    Saved: 'SAVED',
    Planned: 'PLANNED'
});

export const PlanAssignedStatuses = [
    PlanStatusEnum.Assigning,
    PlanStatusEnum.Assigned
];

export const PlanCompletedStatuses = [
    PlanStatusEnum.Planned,
    PlanStatusEnum.Frozen,
    ...PlanAssignedStatuses
];

export const PlanSortByEnum = {
    TaskCountAsc: 'TASK_COUNT_ASC',
    TaskCountDesc: 'TASK_COUNT_DESC',
    WeekDayAsc: 'WEEK_DAY_ASC',
    WeekDayDesc: 'WEEK_DAY_DESC',
    Default: 'DEFAULT'
};

export const PlanStepsEnum = new Enum({
    Upload: 1,
    Geocode: 2,
    Configure: 3,
    EditAndAssignPlan: 4
});

export const CustomFiltersEnum = {
    TaskCount: 'TASK_COUNT'
};

export const PlanExportRowOptionsEnum = {
    SelectedTours: 'selectedTours',
    AllTours: 'allTours'
};

export const AdvancedConfigOptionsStatusEnum = {
    Enabled: 'ENABLED',
    Disabled: 'DISABLED',
    On: 'ON',
    None: 'NONE',
    DefaultFairnessBasedOn: 'task'
};
